/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BenchmarkRunItemSummaryDtoPaginatedResult } from '../../models/benchmark-run-item-summary-dto-paginated-result';

export interface ApiAdminModelVersionsVersionIdBenchmarkRunItemsGet$Params {
  versionId: string;
  cursor?: string;
  limit?: number;
}

export function apiAdminModelVersionsVersionIdBenchmarkRunItemsGet(http: HttpClient, rootUrl: string, params: ApiAdminModelVersionsVersionIdBenchmarkRunItemsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<BenchmarkRunItemSummaryDtoPaginatedResult>> {
  const rb = new RequestBuilder(rootUrl, apiAdminModelVersionsVersionIdBenchmarkRunItemsGet.PATH, 'get');
  if (params) {
    rb.path('versionId', params.versionId, {});
    rb.query('cursor', params.cursor, {});
    rb.query('limit', params.limit, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BenchmarkRunItemSummaryDtoPaginatedResult>;
    })
  );
}

apiAdminModelVersionsVersionIdBenchmarkRunItemsGet.PATH = '/api/Admin/model-versions/{versionId}/benchmark-run-items';
